<template>
  <b-overlay
    :show="__isOnLoad"
    variant="white"
    rounded
    opacity="0.70"
    spinner-variant="primary"
    spinner-small
    style="float: left; width: 100%"
  >
    <b-modal
      v-if="toEditOption !== '' || steDetail"
      v-model="showPopup"
      centered
      :modal-class="popupModalClass"
      :dialog-class="popupDialogClass"
      :content-class="popupContentClass"
      :body-class="popupBodyClass"
      :hide-footer="true"
      :size="popupSize"
      title="" header-class="app-popup-header"
    >
      <Recap v-if="steDetail" :__ID="steDetail" :__showHist="true"></Recap>
      <div v-if="toEditOption" class="managerPopup">
        <div class="managerPopup-top">
          <div>
            <h3 class="managerPopup-title">{{ managerPopupTitle }}</h3>
            <div class="managerPopup-subtitle">{{ managerPopupSubtitle }}</div>
          </div>
        </div>
        <div class="managerPopup-card">
          <Opts :PID="toEditOption" TYPE="DD"></Opts>
        </div>
      </div>
    </b-modal>
    <div :class="styleHeader">
      <div class="row subMenu"  v-if="!__isLightMode">
        <b-button
          size="sm"
          variant="danger"
          style="float: right; margin: 5px"
          :class="{ activeFilterButton: showFilter }"
          @click.stop="toggleFilterPanel()"
          >Filtrer</b-button
        >
        <b-button
          size="sm"
          variant="primary"
          style="float: right; margin: 5px"
          @click="dispatchAdd()"
          >+ Société</b-button
        >
        <b-button
          size="sm"
          variant="primary"
          style="float: right; margin: 5px"
          @click="
            showPopup = true;
            toEditOption = '67786b6ee4f5b22e0ae23681';
          "
          >+ Ville</b-button
        >
        <b-button
          size="sm"
          variant="primary"
          style="float: right; margin: 5px"
          @click="
            showPopup = true;
            toEditOption = '67786b85e4f5b22e0ae23683';
          "
          >+ Banque</b-button
        >
      </div>

      <transition name="filterOverlayFade">
        <div
          v-if="!__isLightMode && __editMode === false && showFilter"
          class="filterOverlay"
          @click="closeFilterPanel"
        ></div>
      </transition>

      <transition name="filterDrawer">
        <div
          class="filterDrawerPanel"
          v-if="!__isLightMode && __editMode === false && showFilter"
          @click.stop
        >
          <div class="filterDrawerHeader">
            <div>
              <div class="filterTitle">Filtres clients</div>
              <div class="filterMeta">{{ filtredListitems.length }} ligne(s) trouvées</div>
            </div>
            <b-button size="sm" variant="outline-secondary" @click="closeFilterPanel">
              Fermer
            </b-button>
          </div>

          <div class="filterDrawerBody">
            <div class="filterSorts">
              <div class="sortTitle">Tri rapide</div>
              <div class="sortGrid">
                <div class="sortItem">
                  <b-icon
                    :class="getIsActifSort(sortFiltre.isDate.state)"
                    icon="check-square-fill"
                    @click="sortFiltre.isDate.state = !sortFiltre.isDate.state"
                  ></b-icon>
                  <span>Date</span>
                  <b-icon
                    class="redColor"
                    v-if="sortFiltre.isDate.state"
                    icon="recycle"
                    @click="sortFiltre.isDate.isUp = !sortFiltre.isDate.isUp"
                  ></b-icon>
                </div>
                <div class="sortItem">
                  <b-icon
                    :class="getIsActifSort(sortFiltre.isName.state)"
                    icon="check-square-fill"
                    @click="sortFiltre.isName.state = !sortFiltre.isName.state"
                  ></b-icon>
                  <span>Nom</span>
                  <b-icon
                    class="redColor"
                    v-if="sortFiltre.isName.state"
                    icon="recycle"
                    @click="sortFiltre.isName.isUp = !sortFiltre.isName.isUp"
                  ></b-icon>
                </div>
                <div class="sortItem">
                  <b-icon
                    :class="getIsActifSort(sortFiltre.isActivated.state)"
                    icon="check-square-fill"
                    @click="sortFiltre.isActivated.state = !sortFiltre.isActivated.state"
                  ></b-icon>
                  <span>Etat</span>
                  <b-icon
                    class="redColor"
                    v-if="sortFiltre.isActivated.state"
                    icon="recycle"
                    @click="sortFiltre.isActivated.isUp = !sortFiltre.isActivated.isUp"
                  ></b-icon>
                </div>
              </div>
            </div>

            <div class="filterField">
              <label>Recherche</label>
              <base-input
                placeholder="Société / tel / fax / email"
                v-model="filterContainer.keySearchSte"
                type="string"
              >
              </base-input>
            </div>

            <div class="filterInlineFields">
              <div class="filterField">
                <label>MF</label>
                <base-input
                  placeholder="Filtre MF"
                  v-model="filterContainer.keySearchMF"
                  type="string"
                >
                </base-input>
              </div>

              <div class="filterField">
                <label>NRC</label>
                <base-input
                  placeholder="Filtre NRC"
                  v-model="filterContainer.keySearchNRC"
                  type="string"
                >
                </base-input>
              </div>

              <div class="filterField">
                <label>CD</label>
                <base-input
                  placeholder="Filtre CD"
                  v-model="filterContainer.keySearchCD"
                  type="string"
                >
                </base-input>
              </div>
            </div>

            <div class="filterField">
              <label>Ville</label>
              <selector
                v-if="toEditOption !== '67786b6ee4f5b22e0ae23681'"
                _id="67786b6ee4f5b22e0ae23681"
                :_editable="true"
                :_asFilter="true"
                :_initFn="setVilleData"
                :_parentItem="filterContainer"
                :_showTitle="false"
                _warpper="filter_ville"
              ></selector>
            </div>

            <div class="filterField">
              <label>Banque</label>
              <selector
                v-if="toEditOption !== '67786b85e4f5b22e0ae23683'"
                _id="67786b85e4f5b22e0ae23683"
                :_editable="true"
                :_asFilter="true"
                :_initFn="setBanqueData"
                :_parentItem="filterContainer"
                :_showTitle="false"
                _warpper="filter_banque"
              ></selector>
            </div>
          </div>
        </div>
      </transition>
    </div>

    <div v-if="__isLightMode" class="lightSearchBar">
      <div class="lightSearchBar-meta">
        <div class="lightSearchBar-title">Recherche client</div>
        <div class="lightSearchBar-count">
          {{ filtredListitems.length }} resultat<span v-if="filtredListitems.length > 1">s</span>
        </div>
      </div>
      <base-input
        v-model="filterContainer.keySearchSte"
        placeholder="Nom, MF, tel, email, ville..."
        type="string"
      ></base-input>
    </div>

    <div :class="getMainPanel">
      <div
        :class="styleSublisteMode + isCurrent(index === showList)"
        v-for="(item, index) in filtredListitems"
        :key="index"
        :style=""
        v-if="__idxOnEdition === -1 || __idxOnEdition === index"
      >

      <div
        class="lightSelectionCard"
        :class="{ 'lightSelectionCard-selected': selectedClientId === item._id }"
        v-if="__isLightMode"
      >
        <button
          type="button"
          class="lightSelectionAction"
          :class="{ 'lightSelectionAction-selected': selectedClientId === item._id }"
          @click="handleLightSelection(item)"
        >
          <b-icon
            icon="check-circle-fill"
            font-scale="1.35"
            aria-hidden="true"
          ></b-icon>
        </button>
        <div class="lightSelectionBody">
          <em class="lightSelectionMeta">
            {{ item.mf || item.tel || item.email || 'Client' }}
          </em>
          <b class="lightSelectionTitle">{{ item.name }}</b>
          <div class="lightSelectionDetails">
            <span>{{ item.ville || 'Ville non renseignée' }}</span>
            <span v-if="item.tel">Tel: {{ item.tel }}</span>
          </div>
        </div>
      </div>

        <div class="companyCard" v-if="!__isLightMode">
          <div class="companyCard-head">
            <div class="companyCard-media">
              <div class="pic">
                <img :src="getTof(item.logo)" style="width: 68px; height: 68px" />
              </div>
            </div>

            <div class="companyCard-main">
              <div class="companyCard-titleRow">
                <div class="companyCard-titleBlock">
                  <div class="companyCard-titleLine">
                    <user
                      v-if="item.isActive == true || item.isActive == 1"
                      class="companyCard-user"
                      :PID="item._id"
                      TYPE="CLIENT"
                      :EMAIL="item.email"
                      :NAME="item.name"
                      :LOGIN="item.login"
                      :PWD="item.pwd || ''"
                    ></user>
                    <b class="companyCard-title">{{ item.name }}</b>
                  </div>
                  <em class="companyCard-subtitle">{{ item.ville || 'Ville non renseignée' }}</em>
                  <em class="companyCard-address" v-if="item.adress">{{ item.adress }}</em>
                </div>
              </div>
            </div>

            <div class="companyCard-menu">
              <div class="menu" v-if="__idxOnEdition !== index && showMenu == index">
                <ico-btn
                  size="p"
                  type="simple"
                  icone="gear-fill"
                  :cb="
                    () => {
                      dispatchEdit(item._id);
                    }
                  "
                ></ico-btn>
                <ico-btn
                  size="p"
                  type="warning"
                  icone="trash"
                  :cb="
                    () => {
                      dispatchDelete(item._id);
                    }
                  "
                ></ico-btn>

                <ico-btn
                  size="p"
                  type="toggleOn"
                  custom="orange"
                  icone="eye-slash-fill"
                  v-if="item.isActive == true"
                  :cb="
                    () => {
                      dispatchDesactive(item._id);
                    }
                  "
                ></ico-btn>
                <ico-btn
                  size="p"
                  type="toggleOff"
                  icone="eye-fill"
                  v-if="item.isActive == false"
                  :cb="
                    () => {
                      dispatchActive(item._id);
                    }
                  "
                ></ico-btn>

                <ico-btn
                  size="p"
                  type="simple"
                  icone="info-circle-fill"
                  :cb="
                    () => {
                      showPopup = true; steDetail = item._id;
                    }
                  "
                ></ico-btn>

                <ico-btn
                  size="p"
                  type="toggleOn"
                  icone="reply-fill"
                  :cb="
                    () => {
                      toggleMenu(index);
                    }
                  "
                ></ico-btn>
              </div>
              <div v-if="__idxOnEdition !== index && showMenu != index">
                <b-icon
                  class="inlineOptionTrigger"
                  :class="
                    getIsActif(item.isActive === true || item.isActive === 1)
                  "
                  icon="gear-fill"
                  aria-hidden="true"
                  @click="toggleMenu(index)"
                ></b-icon>
              </div>
            </div>
          </div>

          <div class="companyCard-body">
            <div class="companyInfoBlock">
              <span class="companyInfoLabel">Coordonnées</span>
              <span class="companyInfoValue">Tél : {{ item.tel || 'Non renseigné' }}</span>
              <span class="companyInfoValue companyInfoValue-break">Email : {{ item.email || 'Non renseigné' }}</span>
              <span class="companyInfoValue">Fax : {{ item.fax || 'Non renseigné' }}</span>
            </div>

            <div class="companyInfoBlock">
              <span class="companyInfoLabel">Informations</span>
              <span class="companyInfoValue">Banque : {{ item.banque || 'Non renseigné' }}</span>
              <span class="companyInfoValue">MF : {{ item.mf || 'Non renseigné' }}</span>
              <span class="companyInfoValue">NRC : {{ item.nrc || 'Non renseigné' }}</span>
              <span class="companyInfoValue">CD : {{ item.cd || 'Non renseigné' }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </b-overlay>
</template>
<script>
import Opts from "@/pages/opts/index";
import user from "@/pages/utilisateurs/index";
import Recap from './Recap';
export default {
  components: {
    Opts,
    user,
    Recap
  },
  props: {
    __idxOnEdition: {
      type: Number,
      default: () => {
        return -1;
      },
    },
    __isOnLoad: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
    __list: {
      type: Array,
      default: () => {
        return [];
      },
    },
    __editMode: {
      type: Boolean,
      default: () => {
        return false;
      },
    },

    __isLightMode: {
      type: Boolean,
      default: () => {
        return false;
      },
    },

    __onSelect: {
      type: Function,
      default: () => {
        () => {};
      },
    },
  },

  data() {
    return {
      filterContainer: {
        keySearchSte: "",
        keySearchMF: "",
        keySearchCD: "",
        keySearchNRC: "",
        filter_ville: "",
        filter_banque: "",
      },
      structure: { vVille: [], vBanque: [] },
      showPopup: null,
      showMenu: -1,
      showList: -1,
      steDetail: null,
      showFilter: false,
      toEditOption: "",
      filtredListitems: [],
      selectionMode: false,
      selectedClientId: null,
      sortFiltre: {
        isDate: { state: false, isUp: true },
        isName: { state: false, isUp: true },
        isActivated: { state: false, isUp: true },
      },
    };
  },
  methods: {
    handleLightSelection(item) {
      this.selectedClientId = item._id;
      this.__onSelect(item);
    },
    normalizeSearchValue(value) {
      return String(value || "").trim().toLowerCase();
    },
    filtredList() {
      var ret = Array.isArray(this.__list) ? [...this.__list] : [];
      const globalSearch = this.normalizeSearchValue(this.filterContainer.keySearchSte);
      const searchMF = this.normalizeSearchValue(this.filterContainer.keySearchMF);
      const searchNRC = this.normalizeSearchValue(this.filterContainer.keySearchNRC);
      const searchCD = this.normalizeSearchValue(this.filterContainer.keySearchCD);

      if (globalSearch)
        ret = ret.filter(
          (e) => {
            const searchableParts = [
              e.name,
              e.adress,
              e.tel,
              e.fax,
              e.email,
              e.ville,
              e.mf,
              e.nrc,
              e.cd,
              e.banque,
            ];

            return searchableParts.some((value) =>
              this.normalizeSearchValue(value).includes(globalSearch)
            );
          }
        );

      if (searchMF)
        ret = ret.filter(
          (e) => this.normalizeSearchValue(e.mf).includes(searchMF)
        );

      if (searchNRC)
        ret = ret.filter(
          (e) => this.normalizeSearchValue(e.nrc).includes(searchNRC)
        );

      if (searchCD)
        ret = ret.filter(
          (e) => this.normalizeSearchValue(e.cd).includes(searchCD)
        );

      if (this.filterContainer.filter_ville)
        ret = ret.filter((e) => e.ville === this.filterContainer.filter_ville);

      if (this.filterContainer.filter_banque)
        ret = ret.filter(
          (e) => e.banque === this.filterContainer.filter_banque
        );

      if (this.sortFiltre.isDate.state === true) {
        if (this.sortFiltre.isDate.isUp)
          ret = ret.sort(
            (a, b) =>
              new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime()
          );
        else
          ret = ret.sort(
            (a, b) =>
              new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
          );
      }

      if (this.sortFiltre.isName.state === true) {
        if (this.sortFiltre.isName.isUp)
          ret = ret.sort((a, b) =>
            String(a.name).localeCompare(String(b.name))
          );
        else
          ret = ret.sort((a, b) =>
            String(b.name).localeCompare(String(a.name))
          );
      }

      if (this.sortFiltre.isActivated.state === true) {
        if (this.sortFiltre.isActivated.isUp)
          ret = ret.filter((a) => a.isActive === 1 || a.isActif === true);
        else ret = ret.filter((b) => b.isActive === 0 || b.isActif === false);
      }

      this.filtredListitems = ret.filter((e) => e.name !== "");
      //return ret;
    },

    setBanqueData(list) {
      this.structure.vBanque = list;
    },

    setVilleData(list) {
      this.structure.vVille = list;
    },

    isCurrent(current) {
      if (this.showList !== -1) return current ? "  actif" : " flowted";
      return "";
    },

    toggleMenu(index) {
      if (this.showMenu != index) {
        this.showMenu = index;
      } else {
        this.showMenu = -1;
      }
    },

    toggleList(index) {
      if (this.showList != index) {
        this.showList = index;
      } else {
        this.showList = -1;
      }
    },

    dispatchEdit(idx) {
      this.$parent.editAction(idx);
    },

    dispatchDelete(idx) {
      this.$bvModal
        .msgBoxConfirm("Veuillez confirmer la suppression.", {
          title: "Confirmation",
          size: "sm",
          buttonSize: "sm",
          okVariant: "danger",
          okTitle: "Confirmer",
          cancelTitle: "Annuler",
          footerClass: "p-2",
          hideHeaderClose: true,
          centered: false,
        })
        .then((value) => {
          if (value) {
            this.$parent.deleteAction(idx);
          }
        });
    },

    dispatchActive(idx) {
      this.$parent.toggleActivateAction(idx, 1);
    },

    dispatchDesactive(idx) {
      this.$parent.toggleActivateAction(idx, 0);
    },

    dispatchAdd() {
      this.$parent.addAction();
    },

    toggleFilterPanel() {
      this.showFilter = !this.showFilter;
    },

    closeFilterPanel() {
      this.showFilter = false;
    },

    getIsActif(isActif) {
      return isActif === true ? "" : "redColor";
    },

    getIsActifSort(isActif) {
      return isActif === false ? "grayColor" : "greenColor";
    },

    getTof(c) {
      return this.__.resolveMediaPath(c, 'uploads/societes/No-Image.jpg');
      // return "http://localhost:5000/uploads/" + c.split("/uploads/")[1];
      // return "./uploads/" + c.split("/uploads/")[1];
    },
  },
  watch: {
    __isOnLoad: function () {},
  },
  computed: {
    popupModalClass() {
      return this.toEditOption
        ? "app-popup-shell price-popup-shell"
        : "app-popup-shell";
    },

    popupDialogClass() {
      return this.toEditOption
        ? "app-popup-dialog price-popup-dialog"
        : "app-popup-dialog";
    },

    popupContentClass() {
      return this.toEditOption
        ? "app-popup-content price-popup-content"
        : "app-popup-content";
    },

    popupBodyClass() {
      return this.toEditOption
        ? "app-popup-body price-popup-body"
        : "app-popup-body";
    },

    popupSize() {
      return this.toEditOption ? "xl" : "m";
    },

    managerPopupTitle() {
      if (this.toEditOption === '67786b6ee4f5b22e0ae23681') {
        return 'Gestion des villes';
      }
      if (this.toEditOption === '67786b85e4f5b22e0ae23683') {
        return 'Gestion des banques';
      }
      return 'Gestion des options';
    },

    managerPopupSubtitle() {
      if (this.toEditOption === '67786b6ee4f5b22e0ae23681') {
        return 'Ajoutez, modifiez et organisez les villes utilisees dans les fiches clients.';
      }
      if (this.toEditOption === '67786b85e4f5b22e0ae23683') {
        return 'Ajoutez, modifiez et organisez les banques utilisees dans les fiches clients.';
      }
      return 'Administration des options clients.';
    },

    styleHeader() {
      return (this.$props.__isLightMode) ? 'row lightHeader' : 'row pageHeader';
    },

    styleSublisteMode() {
      return this.__editMode !== true
        ? (this.$props.__isLightMode) ? "lightMode col-md-12" : "listeMode companyGridCard col-xl-4 col-lg-4 col-md-6 col-sm-12"
        : "editMode col-md-12";
    },

    getMainPanel() {
      if (this.showPopup === false) {
        this.toEditOption = "";
      }
      return (this.$props.__isLightMode) ? '' : "row mainPanelWithoutFilter";
    },
  },
  mounted() {
    setTimeout(() => this.filtredList(), 400);
  },

  watch: {
    __isOnLoad: {
      deep: true,
      handler(newValue, oldValue) {
        console.log("newValueList");
        this.filtredList();
      },
    },
    __list: {
      deep: true,
      handler() {
        this.filtredList();
      },
    },
    __idxOnEdition: {
      deep: true,
      handler(newValue, oldValue) {
        console.log("newValueList");
        this.filtredList();
      },
    },
    filterContainer: {
      deep: true,
      handler(newValue, oldValue) {
        console.log("newValue");
        this.filtredList();
      },
    },
    sortFiltre: {
      deep: true,
      handler(newValue, oldValue) {
        console.log("newValue");
        this.filtredList();
      },
    },
  },
};
</script>
<style scoped>
.companyGridCard {
  margin-bottom: 18px;
}

.lightSelectionCard {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 14px 16px;
  border-radius: 18px;
  background: linear-gradient(180deg, #ffffff 0%, #f8fbff 100%);
  border: 1px solid #dbe4f0;
  box-shadow: 0 14px 28px rgba(15, 23, 42, 0.08);
  transition: border-color 0.18s ease, box-shadow 0.18s ease, background 0.18s ease;
}

.lightSearchBar {
  margin: 0 0 14px;
  padding: 14px 16px 10px;
  border-radius: 18px;
  background: linear-gradient(180deg, #ffffff 0%, #f8fbff 100%);
  border: 1px solid #dbe4f0;
  box-shadow: 0 12px 26px rgba(15, 23, 42, 0.08);
}

.lightSearchBar-meta {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 10px;
}

.lightSearchBar-title {
  color: #1e2a44;
  font-size: 15px;
  font-weight: 700;
}

.lightSearchBar-count {
  color: #64748b;
  font-size: 12px;
  font-weight: 600;
}

.lightSelectionCard-selected {
  background: linear-gradient(180deg, #f3fbf5 0%, #e8f7ec 100%);
  border-color: #b8e0c2;
  box-shadow: 0 16px 30px rgba(22, 163, 74, 0.12);
}

.lightSelectionAction {
  width: 46px;
  height: 46px;
  border: 0;
  border-radius: 999px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #cbd5e1 0%, #94a3b8 100%);
  color: #fff;
  box-shadow: 0 10px 22px rgba(148, 163, 184, 0.24);
  transition: transform 0.18s ease, box-shadow 0.18s ease, background 0.18s ease;
}

.lightSelectionAction-selected {
  background: linear-gradient(135deg, #16a34a 0%, #15803d 100%);
  box-shadow: 0 10px 22px rgba(22, 163, 74, 0.24);
}

.lightSelectionAction:hover {
  transform: translateY(-1px);
  box-shadow: 0 14px 28px rgba(100, 116, 139, 0.24);
}

.lightSelectionAction-selected:hover {
  box-shadow: 0 14px 28px rgba(22, 163, 74, 0.28);
}

.lightSelectionBody {
  flex: 1 1 auto;
  min-width: 0;
}

.lightSelectionMeta {
  display: block;
  margin-bottom: 4px;
  color: #64748b;
  font-size: 12px;
  line-height: 1.4;
  word-break: break-word;
}

.lightSelectionTitle {
  display: block;
  color: #1e2a44;
  font-size: 18px;
  line-height: 1.3;
  margin-bottom: 6px;
}

.lightSelectionDetails {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  color: #475569;
  font-size: 12px;
  line-height: 1.45;
}

.companyCard {
  display: flex;
  flex-direction: column;
  gap: 16px;
  min-height: 100%;
}

.companyCard-head {
  position: relative;
  display: flex;
  align-items: flex-start;
  gap: 14px;
  padding-right: 42px;
}

.companyCard-media {
  flex: 0 0 auto;
}

.companyCard-main {
  flex: 1 1 auto;
  min-width: 0;
}

.companyCard-titleLine {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 6px;
}

.companyCard-user {
  flex: 0 0 auto;
}

.companyCard-title {
  display: block;
  font-size: 18px;
  line-height: 1.25;
  color: #1e2a44;
}

.companyCard-subtitle {
  display: block;
  color: #64748b;
  font-size: 13px;
  line-height: 1.45;
}

.companyCard-address {
  display: block;
  margin-top: 4px;
  color: #94a3b8;
  font-size: 12px;
  line-height: 1.45;
}

.companyCard-menu {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 2;
  display: flex;
  justify-content: flex-end;
}

.companyCard-menu .menu {
  width: auto !important;
  flex-wrap: nowrap !important;
  gap: 2px;
  padding: 10px;
  border: 0;
  border-radius: 12px;
  background: oklch(0.99 0.004 264) !important;
  box-shadow: 0 6px 16px rgba(15, 18, 26, 0.24);
}

.companyCard-menu .menu .btnIco {
  float: none;
  margin: 0;
}

.companyCard-body {
  display: grid;
  grid-template-columns: repeat(1, minmax(0, 1fr));
  gap: 12px;
}

.companyInfoBlock {
  padding: 12px 14px;
  border-radius: 14px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
}

.companyInfoLabel {
  display: block;
  margin-bottom: 6px;
  color: #64748b;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.companyInfoValue {
  display: block;
  color: #1e2a44;
  font-size: 13px;
  line-height: 1.55;
}

.companyInfoValue-break {
  word-break: break-word;
}

@media (max-width: 768px) {
  .companyCard-head {
    flex-wrap: wrap;
  }

  .companyCard-menu {
    width: auto;
  }
}
:deep(.price-popup-shell .modal-dialog) {
  max-width: 980px !important;
}

:deep(.price-popup-content) {
  border-radius: 28px !important;
  background: linear-gradient(180deg, #f4f7fb 0%, #edf2f7 100%) !important;
  box-shadow: 0 30px 70px rgba(15, 23, 42, 0.24) !important;
}

:deep(.price-popup-body) {
  padding: 14px 18px 20px !important;
}

.redColor {
  color: red;
}
.greenColor {
  color: green;
}
.grayColor {
  color: #ccc;
}
.editMode {
  float: left;
  padding: 1%;
  margin-bottom: 10px;
  border-radius: 10px;
  min-height: 40px;
  background-color: #fff;
}
.editMode .menu {
  float: right;
  border-radius: 10px;
  background-color: #fff;
}
.listeMode {
  padding: 1%;
  margin-bottom: 10px;
  border-radius: 10px;
  min-height: 40px;
  background-color: #fff;
}

.listeMode .menu {
  float: right;
  border-radius: 10px;
  background-color: #fff;
}
.pic {
  width: 17%;
  margin-right: 3%;
  float: left;
}
.pic img {
  border-radius: 50%;
}
.preview {
  float: left;
  font-weight: bolder;
}

.listeMode .row,
.editMode .row {
  min-height: 126px;
}

.listeMode .col-md-4,
.editMode .col-md-4 {
  gap: 8px;
}

.listeMode .col-md-4 > b,
.editMode .col-md-4 > b {
  font-size: 22px;
  line-height: 1.1;
  color: #1e2a44;
}

.listeMode .col-md-4 > em,
.editMode .col-md-4 > em {
  font-size: 15px !important;
}

.listeMode .col-md-2,
.listeMode .col-md-3,
.editMode .col-md-2,
.editMode .col-md-3 {
  font-size: 14px;
  line-height: 1.5;
}

.listeMode .col-md-3 b,
.editMode .col-md-3 b {
  font-size: 16px;
}

.preview em {
  font-weight: lighter;
  font-size: 12px;
}

.flowted {
  filter: blur(3.5px);
}

.actif {
  filter: none;
  background-color: #131016;
}

.mainPanelWithoutFilter {
  margin-top: 100px;
}

.activeFilterButton {
  box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.25);
}

.filterOverlay {
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 42, 0.16);
  z-index: 334;
}

.filterDrawerPanel {
  position: fixed;
  top: 119px;
  right: 0;
  width: min(410px, calc(100vw - 36px));
  height: calc(100vh - 148px);
  overflow-x: hidden;
  overflow-y: auto;
  padding: 20px;
  background: linear-gradient(180deg, #ffffff 0%, #f8fafc 100%);
  border-radius: 0;
  box-shadow: 0 22px 55px rgba(15, 23, 42, 0.2);
  border: 1px solid #dbe4f0;
  z-index: 335;
  display: flex;
  flex-direction: column;
}

.filterDrawerHeader {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 18px;
  padding-bottom: 14px;
  border-bottom: 1px solid #e2e8f0;
}

.filterTitle {
  font-size: 22px;
  font-weight: 700;
  color: #0f172a;
}

.filterMeta {
  font-size: 14px;
  color: #64748b;
  margin-top: 5px;
}

.filterDrawerBody {
  display: flex;
  flex-direction: column;
  gap: 18px;
  flex: 1 1 auto;
}

.filterSorts {
  padding: 16px;
  border-radius: 16px;
  background: linear-gradient(180deg, #f8fafc 0%, #f1f5f9 100%);
  border: 1px solid #e2e8f0;
}

.sortTitle {
  font-size: 13px;
  font-weight: 700;
  text-transform: uppercase;
  color: #475569;
  margin-bottom: 12px;
  letter-spacing: 0.04em;
}

.sortGrid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
}

.sortItem {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 14px;
  border-radius: 12px;
  background: #fff;
  border: 1px solid #e2e8f0;
  font-size: 15px;
  color: #334155;
}

.sortItem span {
  flex: 1 1 auto;
}

.filterField label {
  display: block;
  font-size: 15px;
  font-weight: 700;
  color: #475569;
  margin-bottom: 8px;
}

.filterField .form-control,
.filterField .custom-select {
  min-height: 48px;
  font-size: 15px !important;
  border-radius: 12px;
}

.filterInlineFields {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;
}

.filterDrawer-enter-active,
.filterDrawer-leave-active {
  transition: transform 0.28s ease, opacity 0.28s ease;
}

.filterDrawer-enter,
.filterDrawer-leave-to {
  transform: translateX(28px);
  opacity: 0;
}

.filterOverlayFade-enter-active,
.filterOverlayFade-leave-active {
  transition: opacity 0.22s ease;
}

.filterOverlayFade-enter,
.filterOverlayFade-leave-to {
  opacity: 0;
}

.subMenu {
  width: 100%;
  padding-left: 10%;
  padding-right: 10%;
  background-color: black;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 4px;
  min-height: 40px;
  padding-top: 5px;
  padding-bottom: 5px;
}
.pageHeader {
  position: fixed;
  top: 120px;
  left: 0;
  width: 100%;
  z-index: 333;
  background: #f2f2f2;
  overflow: visible;
}
.pageHeader.row,
.subMenu.row,
.lightHeader.row {
  margin-left: 0;
  margin-right: 0;
}
.pageHeader .serachPanel {
  position: fixed;
  top: 119px;
  right: 0;
  width: min(430px, calc(100vw - 36px));
  height: calc(100vh - 148px);
  overflow-x: hidden;
  overflow-y: auto;
  padding: 20px;
  background: linear-gradient(180deg, #ffffff 0%, #f8fafc 100%);
  border-radius: 0;
  box-shadow: 0 22px 55px rgba(15, 23, 42, 0.2);
  border: 1px solid #dbe4f0;
  z-index: 334;
  font-size: 14px;
  animation: filterPanelReveal 0.24s ease;
}
.pageHeader .serachPanel.row {
  margin-left: 0;
  margin-right: 0;
}
.pageHeader .serachPanel [class*="col-"] {
  flex: 0 0 100%;
  max-width: 100%;
  padding: 0 0 10px;
}
.filterPanelHeader {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  padding-bottom: 14px;
  margin-bottom: 14px;
  border-bottom: 1px solid #e2e8f0;
}
.filterPanelTitle {
  font-size: 21px;
  font-weight: 700;
  color: #0f172a;
}
.filterPanelCount {
  font-size: 14px;
  color: #64748b;
  margin-top: 4px;
}
.filterCloseBtn {
  background: #1f2a44;
  color: #fff;
  border: none;
  border-radius: 10px;
  font-size: 13px;
  padding: 7px 14px;
}
.filterQuickTools {
  padding: 14px !important;
  background: linear-gradient(180deg, #f8fafc 0%, #f1f5f9 100%);
  border: 1px solid #e2e8f0;
  border-radius: 0;
  margin-bottom: 8px;
}
.filterQuickTitle {
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  color: #475569;
  margin-bottom: 10px;
  letter-spacing: 0.04em;
}
.pageHeader .serachPanel .form-control,
.pageHeader .serachPanel .custom-select {
  width: 100%;
  min-height: 46px;
  font-size: 15px !important;
  border-radius: 12px;
}
.pageHeader .serachPanel .col-md-1 {
  font-size: 13px !important;
  line-height: 1.6;
}
.pageHeader .serachPanel [class*="col-"] {
  font-size: 15px;
}

@keyframes filterPanelReveal {
  from {
    opacity: 0;
    transform: translateX(24px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}
.lightHeader {
    margin-right: 1px !important;
    margin-left: 1px !important;
  }

  .lightHeader .serachPanel {
    font-size: 11px;

  }

  .lightHeader .serachPanel .form-control  {
    font-size: 11px !important;
    padding: 3px !important;
  }

@media (max-width: 768px) {
  .lightSearchBar {
    padding: 12px;
  }

  .lightSearchBar-meta {
    flex-direction: column;
    align-items: flex-start;
    margin-bottom: 8px;
  }

  .lightSelectionCard {
    padding: 12px 14px;
    gap: 12px;
  }

  .lightSelectionAction {
    width: 42px;
    height: 42px;
  }

  .pageHeader {
    top: 50px;
  }

  .subMenu {
    padding: 6px 10px;
    justify-content: center;
  }

  .filterDrawerPanel {
    top: 119px;
    right: 0;
    width: calc(100vw - 20px);
    height: calc(100vh - 108px);
    padding: 12px;
  }

  .filterDrawerHeader {
    flex-direction: column;
    align-items: stretch;
  }

  .sortGrid,
  .filterInlineFields {
    grid-template-columns: 1fr;
  }

  .mainPanelWithoutFilter {
    margin-top: 110px;
  }
}
  .lightMode {
  padding: 1%;
  margin-bottom: 1px;
  border-radius: 10px;
  margin-left: 1px !important;
  margin-right: 1px !important;
  background-color: #F2F2F2;
  padding-left: 1px !important;
  padding-right: 1px !important;
  font-size: 11px;
}
</style>

